module.exports = __webpack_public_path__ + "img/logo-om-mb.a35fdc77.svg";